<template>
  <div class="my-licence ">
    <div class="account-card">
      <div class="account-card-header" style="margin-bottom:20px">
        <h4 class="account-card-title">我的预交服务费</h4>
      </div>
      <el-form
        :model="form"
        label-width="145px"
        label-suffix=":"
        :rules="rules"
        ref="form"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="订单编号">
              <span>{{ form.orderCode }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="协议编号">
              <span class="cell-link" @click="onLink()">{{
                form.agreementCode
              }}</span>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="协议标题">
          <span>{{ form.agreementTitle }}</span>
        </el-form-item>
        <el-form-item label="方案标题">
          <span>{{ form.planTitle }}</span>
        </el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item label="处置企业">
              <span>{{ form.disposerCompName }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="订单日期">
              <span>{{ form.dealTime }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="订单金额(元)">
              <span>{{ $toFixed.amountGrouping(form.dealTotalPrice) }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="预收服务费金额(元)">
              <span>{{ $toFixed.amountGrouping(form.preChargePrice) }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="预付服务费状态">
              <span style="color:red">{{
                form.statusCode == '0'
                  ? '未支付'
                  : form.statusCode == '1' ||
                    (form.statusCode == '4' && form.fromType == 2)
                  ? '待补交'
                  : form.statusCode == '2' ||
                    (form.statusCode == '4' && form.fromType == 1)
                  ? '支付中'
                  : form.statusCode == '3' && form.fromType == 1
                  ? '已支付成功'
                  : form.statusCode == '3' && form.fromType == 2
                  ? '已补交'
                  : form.statusCode == '11'
                  ? '未支付'
                  : ''
              }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="pageType && form.fromType == 1">
            <el-form-item label="账户余额(元)">
              <span>{{ $toFixed.amountGrouping(form.accountPrice) }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="!pageType || form.fromType == 2">
            <el-form-item label="发货总金额(元)">
              <span v-if="form.shipmentsTotalPrice">{{
                $toFixed.amountGrouping(form.shipmentsTotalPrice)
              }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <div v-if="form.fromType == 2">
          <el-form-item label="补交说明 " v-if="pageType">
            <span>{{ form.remark }}</span>
          </el-form-item>

          <on-Upload
            v-if="pageType"
            :fileList="form.addPreChargefiles"
            labelWidth="140px"
            labelName="补交附件"
            :checkFlag="true"
          ></on-Upload>
          <el-form-item label="需补交金额(元)">
            <span>{{ $toFixed.amountGrouping(form.preChargeAddPrice) }}</span>
          </el-form-item>
        </div>
        <el-row>
          <el-col :span="12" v-if="form.submitTime && form.statusCode != '11'">
            <el-form-item label="支付时间">
              <span>{{ form.submitTime }}</span>
            </el-form-item>
          </el-col>
          <el-col
            :span="12"
            v-if="form.fromType == 2 && form.payOnline == 1 && pageType"
          >
            <el-form-item label="账户余额(元)">
              <span>{{ $toFixed.amountGrouping(form.accountPrice) }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="支付方式" prop="payOnline">
              <el-select
                v-model="form.payOnline"
                placeholder="请选择"
                v-if="pageType && form.fromType == 1"
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                  :disabled="item.disabled"
                >
                </el-option>
              </el-select>
              <span v-else>{{
                form.payOnline == 1 ? '在线支付' : '线下支付'
              }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="支付金额(元)"
              v-if="form.payOnline == 2"
              prop="paidPrice"
            >
              <el-input
                v-if="pageType"
                v-digits-limit="[10, 5]"
                v-model="form.paidPrice"
              ></el-input>
              <span v-else>{{ $toFixed.amountGrouping(form.paidPrice) }}</span>
            </el-form-item>
          </el-col>
        </el-row>

        <on-Upload
          v-if="form.payOnline == 2"
          @fileDataSingle="onfileDataSingle"
          :fileList="form.preChargefiles"
          labelWidth="140px"
          labelName="支付凭证"
          :required="true"
          :checkFlag="!pageType"
        ></on-Upload>
        <div v-if="form.payOnline == 2 && pageType">
          <el-divider content-position="left"
            ><span style="color:red">易派客收款账户信息</span></el-divider
          >
          <el-row>
            <el-col :span="12">
              <el-form-item label="户名">
                <span>{{ form.account.collectionAccount }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="银行账号">
                <span> {{ form.account.accountNumber }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="开户行">
            <span> {{ form.account.bankOfDeposit }}</span>
          </el-form-item>
        </div>
        <div
          v-if="
            form.payOnline == 2 &&
              (form.statusCode == 3 || form.statusCode == 4)
          "
        >
          <el-divider content-position="left">运营确认结果</el-divider>
          <el-form-item label="确认结果">
            <span>{{ form.statusCode == 3 ? '通过' : '不通过' }}</span>
          </el-form-item>
          <el-form-item label="说明">
            <span>{{ form.auditRemark }}</span>
          </el-form-item>
        </div>
        <div v-if="form.payOnline == 2 && pageType">
          <el-divider content-position="left">经办人</el-divider>
          <el-row>
            <el-col :span="12">
              <el-form-item label="联系人" prop="buyerContName">
                <el-input v-model="form.buyerContName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="手机" prop="buyerContMobile">
                <el-input v-model="form.buyerContMobile"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="电话" prop="buyerContPhone">
                <el-input v-model="form.buyerContPhone"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="邮箱" prop="buyerContEmail">
                <el-input v-model="form.buyerContEmail"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div v-if="$route.query.pageType != 'check'">
          <span
            style="color:red"
            v-if="
              form.payOnline == 1 &&
                ((form.preChargePrice > form.accountPrice &&
                  form.payOnline == 1) ||
                  (form.preChargeAddPrice > form.accountPrice &&
                    form.payOnline == 2))
            "
            >您的账户可用余额不足，请先充值确保有足够余额后再进行支付。</span
          >
          <el-divider content-position="left"
            ><span style="color:red">平服务费发票信息</span></el-divider
          >
          <div style="padding-bottom:20px">
            <i class="el-icon-warning" style="color:red"></i>
            请填写您的发票信息，专区将在处置企业等级发货完成后，按照您所填写的信息开具平台服务电费增值税专用发票（税率6%），并邮寄给您。
          </div>

          <el-row>
            <el-col :span="12">
              <el-form-item
                class="form-item"
                label="发票抬头"
                prop="invoice.invoiceTitle"
              >
                <span v-if="form.fromType == 2">{{
                  form.invoice.invoiceTitle
                }}</span>
                <el-select
                  :value="form.invoice.invoiceTitle"
                  placeholder="请选择发票抬头"
                  filterable
                  allow-create
                  value-key="id"
                  @input="invoiceOptions"
                  v-else
                >
                  <el-option
                    v-for="item in invoiceOptionslist"
                    :key="item.id"
                    :label="item.invoiceTitle"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                class="form-item"
                label="纳税人识别号"
                prop="invoice.taxpayerCode"
              >
                <span v-if="form.fromType == 2">{{
                  form.invoice.taxpayerCode
                }}</span>
                <el-input
                  v-else
                  v-model="form.invoice.taxpayerCode"
                  placeholder="请输入纳税人识别号"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item
                class="form-item"
                label="注册地址"
                prop="invoice.regAddress"
              >
                <span v-if="form.fromType == 2">{{
                  form.invoice.regAddress
                }}</span>
                <el-input
                  v-else
                  v-model="form.invoice.regAddress"
                  placeholder="请输入注册地址"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                class="form-item"
                label="注册电话"
                prop="invoice.regPhone"
              >
                <span v-if="form.fromType == 2">{{
                  form.invoice.regPhone
                }}</span>
                <el-input
                  v-else
                  v-model="form.invoice.regPhone"
                  placeholder="请输入注册电话"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item
                class="form-item"
                label="开户银行"
                prop="invoice.bankName"
              >
                <span v-if="form.fromType == 2">{{
                  form.invoice.bankName
                }}</span>
                <el-input
                  v-else
                  v-model="form.invoice.bankName"
                  placeholder="请输入开户银行"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                class="form-item"
                label="银行账号"
                prop="invoice.bankAccountName"
              >
                <span v-if="form.fromType == 2">{{
                  form.invoice.bankAccountName
                }}</span>
                <el-input
                  v-else
                  v-model="form.invoice.bankAccountName"
                  placeholder="请输入银行账号"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item
                class="form-item"
                label="发票邮寄收件人"
                prop="invoice.mailContact"
              >
                <span v-if="form.fromType == 2">{{
                  form.invoice.mailContact
                }}</span>
                <el-input
                  v-else
                  v-model="form.invoice.mailContact"
                  placeholder="请输入发票邮寄收件人"
                  maxlength="100"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                class="form-item"
                label="发票邮寄联系电话"
                prop="invoice.mailMobile"
              >
                <span v-if="form.fromType == 2">{{
                  form.invoice.mailMobile
                }}</span>
                <el-input
                  v-else
                  v-model="form.invoice.mailMobile"
                  placeholder="请输入发票邮寄联系电话"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-form-item
              class="form-item"
              label="发票邮寄信息"
              prop="invoice.mailAddress"
            >
              <span v-if="form.fromType == 2">{{
                form.invoice.mailMobile
              }}</span>
              <el-input
                v-else
                v-model="form.invoice.mailAddress"
                placeholder="请输入发票邮信息"
                maxlength="100"
              ></el-input>
            </el-form-item>
          </el-row>
        </div>
      </el-form>
      <div class="page-index-footer">
        <el-button
          type="primary"
          :disabled="
            form.payOnline == 1 &&
              ((form.preChargePrice > form.accountPrice &&
                form.payOnline == 1) ||
                (form.preChargeAddPrice > form.accountPrice &&
                  form.payOnline == 2))
          "
          @click="onSubmit"
          :loading="loading"
          v-if="pageType"
        >
          支付</el-button
        >
        <el-button @click="$router.go(-1)" :loading="loading">
          <span v-if="pageType">取消</span
          ><span v-if="!pageType">关闭</span></el-button
        >
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      invoiceOptionslist: [],
      loading: false,
      form: {
        addPreChargefiles: [],
        payOnline: null,
        paidPrice: '',
        preChargefiles: [],
        buyerContName: '',
        buyerContMobile: '',
        buyerContPhone: '',
        buyerContEmail: '',
        invoice: {
          type: 0,
          invoiceTitle: '',
          taxpayerCode: '',
          regAddress: '',
          regPhone: '',
          bankName: '',
          bankAccountName: '',
          mailAddress: '',
          id: '',
          mailContact: '',
          mailMobile: ''
        }
      },
      rules: {
        payOnline: [{ required: true, message: ' ', trigger: 'change' }],
        paidPrice: [{ required: true, message: ' ', trigger: 'blur' }],
        buyerContName: [{ required: true, message: ' ', trigger: 'blur' }],
        buyerContMobile: [
          {
            required: true,
            message: '请输入正确的手机号',
            trigger: 'blur',
            pattern: /^1[0-9]{10}$/
          }
        ],
        buyerContEmail: [
          {
            required: false,
            type: 'email',
            message: '请输入正确的格式',
            trigger: 'blur'
          }
        ],
        invoice: {
          invoiceTitle: [{ required: true, message: ' ', trigger: 'blur' }],
          taxpayerCode: [
            {
              required: true,
              pattern: /^[0-9A-Z]{16,20}$/,
              message: '16-20位数字和大写字母',
              trigger: 'blur'
            }
          ],
          regAddress: [{ required: true, message: ' ', trigger: 'blur' }],
          regPhone: [{ required: true, message: ' ', trigger: 'blur' }],
          bankName: [{ required: true, message: ' ', trigger: 'blur' }],
          bankAccountName: [
            { required: true, message: '请输入数字', pattern: /^[0-9]*$/ }
          ],
          mailContact: [{ required: true, message: ' ', trigger: 'blur' }],
          mailMobile: [
            {
              required: true,
              pattern: /^1[0-9]{10}$/,
              message: '请输入手机号码',
              trigger: 'blur'
            }
          ],
          mailAddress: [{ required: true, message: ' ', trigger: 'blur' }]
        }
      },
      options: [
        {
          value: 1,
          label: '在线支付'
        },
        {
          value: 2,
          label: '线下支付'
        }
      ]
    }
  },
  computed: {
    pageType() {
      return this.$route.query.pageType == 'created'
    }
  },
  created() {
    if (this.$route.query.pageType == 'created') {
      this.prechargeInit()

      this.getInvoiceList()
    } else {
      this.prechargeView()
      this.rules = {}
    }
  },
  methods: {
    async prechargeInit() {
      let data = await this.$api.depositPrice.prechargeInit(
        this.$route.query.preChargeId
      )
      console.log(data)
      this.form = {
        ...this.form,
        ...data,
        preChargefiles: data.preChargefiles ? data.preChargefiles : [],
        invoice: data.invoice
          ? data.invoice
          : {
              type: 0,
              invoiceTitle: '',
              taxpayerCode: '',
              regAddress: '',
              regPhone: '',
              bankName: '',
              bankAccountName: '',
              mailAddress: '',
              id: '',
              mailContact: '',
              mailMobile: ''
            }
      }
      if (this.form.fromType == 2) {
        this.rules.invoice = {}
      }
      if (this.form.fromType == 2) {
        if (!this.form.paidPrice) {
          this.form.paidPrice = this.form.preChargeAddPrice
        }
      } else {
        if (!this.form.paidPrice) {
          this.form.paidPrice = this.form.preChargePrice
        }
      }

      if (this.form.payOnlineWhether != 1) {
        this.options = [
          {
            value: 2,
            label: '线下支付'
          },
          {
            value: 1,
            label: '在线支付',
            disabled: true
          }
        ]
      }
    },
    async prechargeView() {
      let data = await this.$api.depositPrice.prechargeView(
        this.$route.query.preChargeId
      )
      console.log(data)
      this.form = data
    },
    onfileDataSingle(val) {
      this.form.preChargefiles = val
    },
    async getInvoiceList() {
      let data = await this.$api.order.getInvoiceList()

      this.invoiceOptionslist = data
    },
    onSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (
            this.form.payOnline == 2 &&
            this.form.preChargefiles &&
            this.form.preChargefiles.length == 0
          ) {
            this.$message.error('请上传支付凭证')
          } else {
            this.prechargeSave()
          }
        } else {
          return false
        }
      })
    },
    async prechargeSave() {
      let params = {
        preChargeId: this.$route.query.preChargeId,
        invoice: this.form.invoice,
        fileList: this.form.preChargefiles,
        paidPrice: this.form.paidPrice,
        payOnline: this.form.payOnline,
        buyerContEmail: this.form.buyerContEmail,
        buyerContMobile: this.form.buyerContMobile,
        buyerContName: this.form.buyerContName,
        buyerContPhone: this.form.buyerContPhone
      }
      this.loading = true
      let data
      if (this.form.fromType == 1) {
        data = await this.$api.depositPrice.prechargeSave(params)
      } else {
        data = await this.$api.depositPrice.prechargeAdd(params)
      }
      this.loading = false
      if (data) {
        this.$message.success('支付成功')
        this.$router.go(-1)
      }
    },
    onLink() {
      let query = {
        agreementId: this.form.agreementId,
        buyerCompCode: this.form.disposerCompCode
      }
      this.$openNewPage('AgreementDetail', query)
    },
    invoiceOptions(value) {
      console.log(value)
      if (typeof value == 'string') {
        this.form.invoice.invoiceTitle = value
      } else {
        this.form.invoice = value
      }
    }
  }
}
</script>
<style lang="less" scoped>
::v-deep .el-divider--horizontal {
  margin: 35px 0;
}
</style>
